// eslint-disable-next-line import/prefer-default-export
export const ORDERS_STATUS = {
  NEW: 'New',
  PROCESSING: 'Processing',
  PROCESSED: 'Processed'
};
